
























import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IFormOption } from '@/components/form/FieldTypes'
import FieldCondition from '@/components/form/FieldCondition.vue'

@Component({
  components: { FieldCondition },
})
export default class Field extends Vue {
  @Prop({ default: [], required: true, type: Array }) protected options!: IFormOption[]
  @Prop({ type: Object, default: () => ({}) }) protected value!: any
  @Prop({ default: () => ({})}) protected form!: any

  protected mutation(): object {
    const data = {}
    this.options.forEach((item) => {
      if (item.props) {
        data[item.props.name] = _.isUndefined(_.get(this.value, item.props.name, undefined))
          ? _.isUndefined(item.props.defaultValue)
            ? null
            : item.props.defaultValue
          : _.get(this.value, item.props.name, null)
      }
    })

    return data
  }
}
